(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cardori-twist-set-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cardori-twist-set-configurator-v2')) {
  class CardoriTwistSetConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.initializationStarted) return;
      this.initializationStarted = true;

      Promise.all([
        customElements.whenDefined('variant-picker'),
        customElements.whenDefined('custom-select')
      ]).then(() => this.initialize());
    }

    initialize() {
      if (this.initialized) return;

      this.section = this.closest('.shopify-section');
      this.productForm = this.section ? this.section.querySelector('product-form') : null;
      this.submitForm = this.productForm ? this.productForm.querySelector('.js-product-form') : null;
      this.variantData = this.querySelector('[data-cardori-twist-variants]');
      this.controls = Array.from(this.querySelectorAll('[data-cardori-colour], [data-cardori-length]'));
      this.cards = Array.from(this.querySelectorAll('.cardori-twist-set__bracelet'));
      this.header = this.querySelector('.cardori-twist-set__header');

      if (!this.productForm || !this.submitForm || !this.section || !this.variantData) return;

      try {
        this.variants = JSON.parse(this.variantData.textContent);
      } catch (error) {
        return;
      }

      if (!this.variants.length || !this.getNativePicker()) return;

      this.initialized = true;
      this.engravingValues = new Map();
      this.engravingInputs = new Map();
      this.productForm.addEventListener('input', (event) => {
        const input = event.target;
        if (input.matches('#customily-options input[type="text"][name^="properties[Armband "]')) {
          this.engravingValues.set(input.name, input.value);
        }
      });
      this.controls.forEach((control) => {
        control.addEventListener('change', () => this.selectVariant());
      });
      this.productForm.addEventListener('click', (event) => {
        const submitButton = event.target.closest('button[type="submit"], [name="add"]');
        if (!submitButton || !this.productForm.contains(submitButton)) return;

        const selectedVariant = this.getSelectedVariant();
        if (selectedVariant) this.syncVariantId(selectedVariant.id);
      }, { capture: true });
      this.productForm.addEventListener('submit', () => {
        const selectedVariant = this.getSelectedVariant();
        if (selectedVariant) this.syncVariantId(selectedVariant.id);
      }, { capture: true });
      this.section.addEventListener('on:variant:change', (event) => {
        if (!event.detail || !event.detail.variant) return;
        this.syncControls(event.detail.variant.options);
        this.syncVariantId(event.detail.variant.id);
      });

      this.productForm.classList.add('cardori-twist-set-ready');

      const initialVariant = this.getSelectedVariant();
      if (initialVariant) this.syncVariantId(initialVariant.id);
      this.customilyObserver = new MutationObserver(() => {
        if (this.layoutFrame) return;
        this.layoutFrame = requestAnimationFrame(() => {
          this.layoutFrame = null;
          this.integrateCustomily();
        });
      });
      this.customilyObserver.observe(this.productForm, { childList: true, subtree: true });
      this.integrateCustomily();
    }

    disconnectedCallback() {
      this.customilyObserver?.disconnect();
      if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
    }

    integrateCustomily() {
      const root = this.productForm.querySelector('#customily-options');
      if (!root) return;
      const names = ['Armband oben (links)', 'Armband oben (rechts)', 'Armband unten (links)', 'Armband unten (rechts)'];
      const options = names.map((name) => {
        const input = root.querySelector('input[name="properties[' + name + ']"]');
        return input?.closest('.customily_option');
      });
      if (options.some((option) => !option)) return;
      const parent = options[0].parentElement;
      if (!options.every((option) => option.parentElement === parent)) return;
      parent.classList.add('cardori-twist-customily');
      options.forEach((option, index) => {
        const input = option.querySelector('input[type="text"]');
        if (this.engravingInputs.get(input.name) !== input) {
          this.engravingInputs.set(input.name, input);
          if (this.engravingValues.has(input.name)) {
            const saved = this.engravingValues.get(input.name);
            if (saved !== input.value && (input.maxLength < 0 || saved.length <= input.maxLength)) {
              input.value = saved;
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            this.engravingValues.set(input.name, input.value);
          }
        }
        option.classList.add('cardori-twist-engraving');
        const side = index % 2 === 0 ? 'left' : 'right';
        option.dataset.cardoriSide = side;
        const text = option.querySelector('.option_name > div');
        const label = side === 'left' ? 'Gravur links' : 'Gravur rechts';
        const textNode = text && Array.from(text.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
        if (textNode && textNode.textContent.trim() !== label) textNode.textContent = label + ' ';
      });
      const selectedVariant = this.getSelectedVariant();
      if (selectedVariant) this.syncSetDetails(selectedVariant.id);
      const setFields = ['Oberes Armband', 'Unteres Armband'].map((label) =>
        Array.from(this.productForm.querySelector('.js-product-form').elements)
          .find((input) => input.name === 'properties[' + label + ']')
      );
      this.cards.forEach((card, index) => {
        const anchor = options[index * 2];
        if (card.parentElement !== parent || card.nextElementSibling !== anchor) parent.insertBefore(card, anchor);
        const field = setFields[index];
        if (field && (field.parentElement !== parent || field.nextElementSibling !== card)) parent.insertBefore(field, card);
      });
      const headerAnchor = setFields[0] || this.cards[0];
      if (this.header.parentElement !== parent || this.header.nextElementSibling !== headerAnchor) {
        parent.insertBefore(this.header, headerAnchor);
      }
      this.classList.add('cardori-twist-set--integrated');
      this.parentElement.classList.add('cardori-twist-empty-block');
    }

    getNativePicker() {
      const picker = this.productForm.querySelector('variant-picker');
      if (!picker) return null;

      const selectors = picker.querySelectorAll('.option-selector');
      return selectors.length === 3 ? picker : null;
    }

    getSelections() {
      const upperColour = this.productForm.querySelector('[data-cardori-colour="upper"]').value;
      const lowerColour = this.productForm.querySelector('[data-cardori-colour="lower"]').value;
      const upperLength = this.productForm.querySelector('[data-cardori-length="upper"]').value;
      const lowerLength = this.productForm.querySelector('[data-cardori-length="lower"]').value;

      return [
        `${upperColour} oben · ${lowerColour} unten`,
        upperLength,
        lowerLength
      ];
    }

    getSelectedVariant() {
      const options = this.getSelections();
      return this.variants.find((item) => item.options.every((value, index) => value === options[index]));
    }

    selectVariant() {
      const options = this.getSelections();
      const variant = this.getSelectedVariant();
      const picker = this.getNativePicker();

      if (!variant || !picker) return;

      let eventTarget = null;
      options.forEach((value, index) => {
        const selector = picker.querySelector(`.option-selector[data-index="${index + 1}"]`);
        if (!selector) return;

        const desiredOption = Array.from(selector.querySelectorAll('.custom-select__option'))
          .find((option) => option.dataset.value === value);
        const customSelect = desiredOption ? desiredOption.closest('custom-select') : null;
        if (!desiredOption || !customSelect) return;

        const selectedOption = customSelect.querySelector('.custom-select__option[aria-selected="true"]');
        if (selectedOption && selectedOption !== desiredOption) {
          selectedOption.setAttribute('aria-selected', 'false');
        }
        desiredOption.setAttribute('aria-selected', 'true');
        customSelect.selectedOption = desiredOption;
        if (customSelect.nativeSelect) customSelect.nativeSelect.value = desiredOption.dataset.value;
        customSelect.button.firstElementChild.textContent = desiredOption.firstElementChild.textContent;
        customSelect.listbox.setAttribute('aria-activedescendant', desiredOption.id);
        eventTarget = customSelect;
      });

      if (!eventTarget) return;

      this.syncVariantId(variant.id);
      eventTarget.dispatchEvent(new CustomEvent('change', {
        bubbles: true,
        cancelable: false,
        detail: {
          selectedValue: options[2],
          variantId: String(variant.id),
          noFocus: true
        }
      }));
    }

    syncVariantId(variantId) {
      const idInput = this.productForm.querySelector('input[name="id"]');
      if (!idInput || !variantId) return;

      idInput.value = String(variantId);
      idInput.setAttribute('value', String(variantId));
      this.syncSetDetails(variantId);
    }


    syncSetDetails(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      const form = this.submitForm || this.productForm.querySelector('.js-product-form');
      if (!variant || !form || !Array.isArray(variant.options) || variant.options.length !== 3) return;
      const colours = variant.options[0].match(/^(.+) oben · (.+) unten$/);
      if (!colours) return;
      [[1, 'Unteres Armband'], [0, 'Oberes Armband']].forEach(([index, label]) => {
        const name = 'properties[' + label + ']';
        let field = Array.from(form.elements).find((input) => input.name === name);
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.name = name;
          form.prepend(field);
        }
        let length = variant.options[index + 1];
        if (!length.includes('Verlängerung')) length += ' Verlängerung';
        const value = colours[index + 1] + ' · ' + length;
        if (field.value !== value) {
          field.value = value;
          field.setAttribute('value', value);
        }
      });
    }

    syncControls(options) {
      if (!Array.isArray(options) || options.length !== 3) return;

      const colourParts = options[0].split(' oben · ');
      const lowerColour = (colourParts[1] || '').replace(/ unten$/, '');
      const values = [colourParts[0], lowerColour, options[1], options[2]];
      const selectors = [
        '[data-cardori-colour="upper"]',
        '[data-cardori-colour="lower"]',
        '[data-cardori-length="upper"]',
        '[data-cardori-length="lower"]'
      ];

      selectors.forEach((selector, index) => {
        const control = this.productForm.querySelector(selector);
        if (control && values[index]) control.value = values[index];
      });
    }
  }

  customElements.define('cardori-twist-set-configurator-v2', CardoriTwistSetConfigurator);
}
  } catch(e) { console.error(e); }
})();

})();
